export const LETTER_PAGE_WIDTH_PT = 612;
export const LETTER_PAGE_HEIGHT_PT = 792;
export const LETTER_PAGE_MARGIN_PT = 54;
export const LETTER_BODY_FONT_SIZE_PT = 11;

/** Shared layout contract with PDF renderer and HTML preview. */
export const LETTER_PARAGRAPH_LINE_HEIGHT = 1.35;
export const LETTER_HEADING_LINE_HEIGHT = 1.25;
export const LETTER_PARAGRAPH_SPACING_AFTER_PT = 9;
export const LETTER_HEADING_SPACING_AFTER_PT = Object.freeze({ 1: 12, 2: 9, 3: 6 });

export const LETTER_PRINTABLE_WIDTH_PT = LETTER_PAGE_WIDTH_PT - LETTER_PAGE_MARGIN_PT * 2;
export const LETTER_PRINTABLE_HEIGHT_PT = LETTER_PAGE_HEIGHT_PT - LETTER_PAGE_MARGIN_PT * 2;

export {
  LETTER_TEMPLATE_QR_CALLOUT_BACKGROUND_COLOR as LETTER_QR_CALLOUT_BACKGROUND_COLOR,
  LETTER_TEMPLATE_QR_CALLOUT_BORDER_COLOR as LETTER_QR_CALLOUT_BORDER_COLOR,
  LETTER_TEMPLATE_QR_CALLOUT_BORDER_WIDTH_PT as LETTER_QR_CALLOUT_BORDER_WIDTH_PT,
  LETTER_TEMPLATE_QR_CALLOUT_GAP_PT as LETTER_QR_CALLOUT_GAP_PT,
  LETTER_TEMPLATE_QR_CALLOUT_HEIGHT_PT as LETTER_QR_CALLOUT_HEIGHT_PT,
  LETTER_TEMPLATE_QR_CALLOUT_MAX_HEIGHT_PT as LETTER_QR_CALLOUT_MAX_HEIGHT_PT,
  LETTER_TEMPLATE_QR_CALLOUT_PADDING_PT as LETTER_QR_CALLOUT_PADDING_PT,
  LETTER_TEMPLATE_QR_CALLOUT_QR_BACKGROUND_COLOR as LETTER_QR_CALLOUT_QR_BACKGROUND_COLOR,
  LETTER_TEMPLATE_QR_CALLOUT_RADIUS_PT as LETTER_QR_CALLOUT_RADIUS_PT,
  LETTER_TEMPLATE_QR_CALLOUT_SPACING_AFTER_PT as LETTER_QR_CALLOUT_SPACING_AFTER_PT,
  LETTER_TEMPLATE_QR_CALLOUT_SPACING_BEFORE_PT as LETTER_QR_CALLOUT_SPACING_BEFORE_PT,
  LETTER_TEMPLATE_QR_CALLOUT_SUBTITLE_COLOR as LETTER_QR_CALLOUT_SUBTITLE_COLOR,
  LETTER_TEMPLATE_QR_CALLOUT_SUBTITLE_EN as LETTER_QR_CALLOUT_SUBTITLE_EN,
  LETTER_TEMPLATE_QR_CALLOUT_SUBTITLE_FR as LETTER_QR_CALLOUT_SUBTITLE_FR,
  LETTER_TEMPLATE_QR_CALLOUT_TITLE_COLOR as LETTER_QR_CALLOUT_TITLE_COLOR,
  LETTER_TEMPLATE_QR_CALLOUT_TITLE_EN as LETTER_QR_CALLOUT_TITLE_EN,
  LETTER_TEMPLATE_QR_CALLOUT_TITLE_FR as LETTER_QR_CALLOUT_TITLE_FR,
  LETTER_TEMPLATE_QR_CALLOUT_WIDTH_PT as LETTER_QR_CALLOUT_WIDTH_PT,
  LETTER_TEMPLATE_QR_PLACEHOLDER_LABEL as LETTER_QR_PLACEHOLDER_LABEL,
  LETTER_TEMPLATE_QR_PLACEHOLDER_SIZE_PT as LETTER_QR_PREVIEW_WIDTH_PT,
  LETTER_TEMPLATE_QR_QUIET_ZONE_PT as LETTER_QR_QUIET_ZONE_PT,
  computeLetterTemplateQrCalloutLayout,
} from '../../../../functions/admin/letterTemplateQrCallout.js';

/** Browser preview: 1 PDF point = 1 CSS px before visual scale. */
export const LETTER_PREVIEW_MAX_WIDTH_CSS = '8.5in';

/**
 * @param {number} logicalPt
 * @returns {string}
 */
export function letterLogicalCssPx(logicalPt) {
  return `${logicalPt}px`;
}

/**
 * @param {number} availableCssWidth
 */
export function computeLetterTemplatePreviewScale(availableCssWidth) {
  if (!Number.isFinite(availableCssWidth) || availableCssWidth <= 0) return 1;
  return availableCssWidth / LETTER_PAGE_WIDTH_PT;
}
